export default class KioskLocationPickerCtrl {
  constructor($uibModalInstance, locations) {
    'ngInject';

    Object.assign(this, { $uibModalInstance, locations });
  }

  onAllChange() {
    this.locations = this.locations.map((location) => ({
      ...location,
      checked: this.allChecked,
    }));
    this.setCanLaunchFlag();
  }

  optionChanged(location) {
    location.checked = !location.checked;
    this.setCanLaunchFlag();

    const allCheckedOrUnchecked = this.locations.every((loc) => loc.checked === location.checked);
    if (allCheckedOrUnchecked) {
      this.allChecked = location.checked;
    } else if (!location.checked && this.allChecked) {
      this.allChecked = false;
    }
  }

  setCanLaunchFlag() {
    this.canLaunch = this.locations.some((loc) => loc.checked);
  }

  launch() {
    const checked = this.locations.filter((location) => location.checked);
    if (checked.length) {
      this.$uibModalInstance.close(checked);
    }
  }

  cancel() {
    this.$uibModalInstance.close();
  }
}
